import { createContext, useContextSelector } from 'use-context-selector'
import { type Certificate } from '../../../Certificate/certificate'

export interface ExtendedCertificate extends Certificate {
  imageWithBackground?: string | null
}

export interface TalentCardContextType {
  certificate?: ExtendedCertificate
  onClick?: () => void
  clubImg?: string
  schoolImg?: string
}

export const TalentCardContext = createContext<TalentCardContextType>({})

export const useTalentCardContext = (): TalentCardContextType => useContextSelector(TalentCardContext, ctx => ctx)
